// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"VrmLookupSectionMobile_sectionContainer__Fg2E5","subtitle":"VrmLookupSectionMobile_subtitle__KYW5l","callUsText":"VrmLookupSectionMobile_callUsText__ysLuc"};